import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import {report_installation_summary, report_repair} from "../../../components/Report.js";
export default class DetailRepairs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_serialno: false,
      data: [],
      data_warehouse: [],
      data_bank: [],
      data_product: [],
      data_so: [],

      transaction_list: [],
      stock_activity_list: [],
      transaction_spare_part: [],
      transaction_main: [],
      transaction_so: [],

      product_index: -1,
      serial_list: [],

      is_change: false,

      id: "",
      uid: "",
      address: "",
      brand: "",
      car_registration: "",
      cause: "",
      customer_id: "",
      customer_name: "",
      customer: "",
      date: "",
      document_no: "",
      model: "",
      phone: "",
      status: "",
      type: "",
      user: "",
      warehouse: "",
      payment_type: "",
      receipt_type: "",
      ref_number: "",

      total_pay: "",
      amount_deposit: "",
      amount_deposit_need: "",
      cash_amount: "",
      transfer_amount: "",
      transfer_bank_account: "",
      transfer_date: "",
      transfer_time: "",
      credit_amount: "",
      credit_bank_account: "",
      credit_date: "",
      check_number: "",
      is_vat: false,
      discount: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
    if (params("id")) {
      this.GetByID(params("id"));
    }
  }
  Get = async (page) => {
    let data_bank, data_product, data_warehouse, data_so;
    loading(true);
    let [result_bank, result_product, result_warehouse, result_so] = await Promise.all([
      GET("admin/setting/banks/list", { page: 0, data_search: "" }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/sales/list", { page: 0, data_search: "", status_code: "เสร็จสิ้น" })
    ]);
    if (result_bank?.status) {
      data_bank = result_bank.data
        .map((e) => ({
          value: e.uid,
          label: `${e.bank_name} : ${e.account_number} (${e.account_name})`,
          is_default: e.is_default, // เก็บไว้ใช้ sort
        }))
        .sort((a, b) => (b.is_default === true) - (a.is_default === true));
    }

    if (result_product?.status) {
      data_product = result_product.data
        ?.filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          balance: e.balance,
          serial_number: e.serial_number,
        }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_so?.status) {
      data_so = result_so.data.map((e) => ({
        value: e.document_no,
        label: e.document_no,
        uid: e.uid
      }));
    }
    this.setState({
      data_bank,
      data_product,
      data_warehouse,
      data_so
    });
    loading(false);
  };
  GetByID = async (id) => {
    const {data_so} = this.state;
    loading(true);
    let result = await GET("admin/repairs/list", {
      uid: id,
    });
    if (result?.status) {
      this.setState({
        ...result.data,
        date: format_date(result.data.date, "yyyy-mm-dd", "en"),
        stock_activity_list: result.data.stock_activity_list.sort((a, b) =>
          a.document_no.localeCompare(b.document_no)
        ),

        transaction_spare_part: result.data.transaction_spare_part.map((e) => ({
          ...e,
          product_id: e.product?.uid,
          warehouse_id: e.warehouse?.uid,
        })),
        transaction_main: result.data.transaction_main.map((e) => ({
          ...e,
          product_id: e.product?.uid,
          warehouse_id: e.warehouse?.uid,
        })),
        customer_name: ["","-",null,undefined].includes(result.data.customer_name) ? result.data.customer?.full_name : result.data.customer_name,
      }, () => {
        const billed = this.calcBilled();
        const totalPay = Number(this.state.total_pay);
        const amountDeposit = Number(this.state.amount_deposit);
        this.setState({
          amount_deposit_need: this.calcDefaultPaymentNeed(
            billed,
            totalPay,
            amountDeposit
          ),
        });
      });
      if(result.data.ref_number){
        this.GetSO(data_so.find(e=>e.value === result.data.ref_number)?.uid);
      }
    }

    loading(false);
  };
  GetSO = async (uid) => {
    loading(true);
    let result = await GET("admin/sales/list", {uid});
  
    if (result?.status) {
      const item = result.data;
      
      this.setState({transaction_so: item.transaction_list}, () => {
        const billed = this.calcBilled();
        const totalPay = Number(this.state.total_pay);
        const amountDeposit = Number(this.state.amount_deposit);
        this.setState({
          amount_deposit_need: this.calcDefaultPaymentNeed(
            billed,
            totalPay,
            amountDeposit
          ),
        });
      });
    }
     loading(false);
  }
  calcBilled = () => {
    const {
      stock_activity_list,
      transaction_list,
      transaction_spare_part,
      transaction_so,
      discount,
      receipt_type,
    } = this.state;
    let total = 0;
    stock_activity_list.forEach((e) => {
      e.transaction_list.forEach((tx) => {
        total += Number(tx.sale_price);
      });
    });
    transaction_list.forEach((e) => {
      total += Number(e.sale_price);
    });
    transaction_spare_part.forEach((e) => {
      total += Number(e.sale_price);
    });
    transaction_so.forEach((e) => {
      total -= Number(e.unit_price) * Number(e.qty);
    });
    total -= Number(discount);
    if (receipt_type === "ต้องการ Vat") {
      total = total * 1.07;
    }
    return total;
  };
  calcOutstanding = () => {
    return this.calcBilled() - Number(this.state.total_pay ?? 0);
  };
  normalizeAmount = (value) => Number(toFixed(value).replaceAll(",", ""));
  calcDefaultPaymentNeed = (billed, totalPay, amountDeposit) => {
    if (totalPay < amountDeposit) {
      return amountDeposit - totalPay;
    }
    return Math.max(0, billed - totalPay);
  };

  Update = async (_status) => {
    const {
      uid,
      status,
      address,
      brand,
      car_registration,
      cause,

      customer_name,

      model,
      phone,
      type,
      payment_type,
      receipt_type,
      stock_activity_list,
      transaction_list,
      transaction_spare_part,
      transaction_main,
      transaction_so,

      is_change,

      amount_deposit_need,
      amount_deposit,
      cash_amount,
      transfer_amount,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,
      total_pay,
      discount,
      ref_number
    } = this.state;

    let is_none_price = false;
    if (_status === "รอชำระ") {
      stock_activity_list.forEach((e) => {
        e.transaction_list.forEach((tx) => {
          if (Number(tx.sale_price) === 0) {
            is_none_price = true;
          }
          if(!tx.sale_price){
            tx.sale_price = 0
          }
          if(!tx.cost_price){
            tx.cost_price = 0
          }
        });
      });
      transaction_list.forEach((e) => {
        if (Number(e.sale_price) === 0) {
          is_none_price = true;
        }
          if(!e.sale_price){
            e.sale_price = 0
          }
          if(!e.cost_price){
            e.cost_price = 0
          }
      });
      transaction_spare_part.forEach((e) => {
        if (Number(e.sale_price) === 0) {
          is_none_price = true;
        }
          if(!e.sale_price){
            e.sale_price = 0
          }
          if(!e.cost_price){
            e.cost_price = 0
          }
      });
    }
    if (is_none_price) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาขาย");
      return;
    }

    const total_pay_amount =
      Number(cash_amount) + Number(transfer_amount) + Number(credit_amount);
    const _total = this.calcBilled();
    if (
      payment_type !== "ชำระเชื่อ" &&
      _status === "เสร็จสิ้น" &&
      type === "ซ่อมให้ลูกค้า"
    ) {
      const outstanding = this.normalizeAmount(this.calcOutstanding());
      const payment_need = this.normalizeAmount(amount_deposit_need);

      if (total_pay_amount > 0) {
        if (payment_need <= 0) {
          alert(
            "",
            "warning",
            "แจ้งเตือน",
            "ยอดเงินที่ต้องการชำระต้องมากกว่า 0 บาท"
          );
          return;
        }

        if (this.normalizeAmount(total_pay_amount) !== payment_need) {
          alert(
            "",
            "warning",
            "แจ้งเตือน",
            "ยอดชำระไม่เท่ากับยอดเงินที่ต้องการชำระ"
          );
          return;
        }

        if (this.normalizeAmount(total_pay_amount) > outstanding + 0.01) {
          alert(
            "",
            "warning",
            "แจ้งเตือน",
            "ยอดชำระเกินมูลค่าเต็มจำนวนสั่งซื้อ"
          );
          return;
        }
      }

      if (total_pay_amount === 0) {
        _status = "รอชำระ";
      } else if (outstanding <= this.normalizeAmount(total_pay_amount)) {
        _status = "เสร็จสิ้น";
      } else {
        _status = "รอชำระ";
      }
    }

    if (is_change) {
      let re_sale = await Promise.all(
        stock_activity_list.map((e) =>
          this.UpdatePrice(e.uid, e.transaction_list)
        )
      );
      if (!re_sale.every((e) => e)) {
        loading(false);
        return;
      }
    }
    
    
    // return
    loading(true);
    let body = {
      status: _status || status,
      address,
      brand,
      car_registration,
      cause,

      customer_name,

      model,
      phone,
      payment_type,
      receipt_type,
      transaction_list: transaction_list.map((e) => ({
        ...e,
        cost_price: Number(e.cost_price),
        unit_price: Number(e.unit_price),
        sale_price: Number(e.sale_price),
      })),
      transaction_spare_part: transaction_spare_part.map((e) => ({
        ...e,
        cost_price: Number(e.cost_price),
        unit_price: Number(e.unit_price),
        sale_price: Number(e.sale_price),
        type: type,
      })),
      transaction_main: transaction_main.map((e) => ({
        ...e,
        cost_price: Number(e.cost_price),
        unit_price: Number(e.unit_price),
        sale_price: Number(e.sale_price),
        type: type,
      })),

      amount_deposit,
      cash_amount,
      transfer_amount,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,
      total_pay: Number(total_pay) + Number(total_pay_amount),
      amount: Number(_total),
      discount: Number(discount),
      is_vat: receipt_type === "ต้องการ Vat",
      amount_net: Number(_total),
      due_date:
        _status === "เสร็จสิ้น"
          ? format_date(
              new Date(new Date().getFullYear(), new Date().getMonth() + 1, 25),
              "yyyy-mm-dd",
              "en"
            )
          : null,
      ref_number
    };

    let result = await PUT("admin/repairs/update/" + uid, body);
    if (result?.status) {
      alert(_status === "เสร็จสิ้น" ? "/repair/repairs" : "#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };
  UpdatePrice = async (uid, transaction_list, status = "เสร็จสิ้น") => {
    const { receipt_type } = this.state;
    let amount = 0;

    for (let item of transaction_list) {
      if (!item.unit_price || Number(item.unit_price) <= 0) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
        return;
      }
      if (!item.sale_price || Number(item.sale_price) <= 0) {
        alert("", "warning", "แจ้งเตือน", "กรุณากรอกราคาต่อหน่วย");
        return;
      }
      amount +=
        Number(item.qty) * (Number(item.unit_price) || 0) -
        (Number(item.discount) || 0);
    }

    loading(true);
    let body = {
      amount: Number(amount),
      is_vat: receipt_type === "ต้องการ Vat",
      amount_net: Number(amount),
      status: status,
      count_order: transaction_list.length,
      count_item: total(transaction_list, "qty"),
      receipt_type: receipt_type || "ไม่ต้องการ Vat",
      withdrawal_type: "เบิกแจ้งซ่อม",

      transaction_list: transaction_list.map((e) => ({
        ...e,
        product_id: e.product?.uid,
        cost_price: Number(e.cost_price),
        unit_price: Number(e.unit_price),
        sale_price: Number(e.sale_price),
      })),
    };

    let result = await PUT("admin/stock-activities/update/" + uid, body);
    return result.status;
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบรายการนี้หรือไม่ ?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await DELETE("banks/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  calCostPrice = () => {
    let { transaction_main, stock_activity_list, transaction_list } = this.state;
    if( transaction_main.length === 0 ) return;
    let _total = 0;
    stock_activity_list.forEach((e) => {
      e.transaction_list.forEach((tx) => {
        _total += Number(tx.sale_price);
      });
    });
transaction_list.forEach((e) => {
      _total += Number(e.sale_price);
    });
    transaction_main[0].cost_price = _total;
    this.setState({transaction_main})
  }
  render() {
    const {
      modal_serialno,

      data_bank,
      data_warehouse,
      data_product,
      data_so,

      transaction_list,
      stock_activity_list,
      transaction_spare_part,
      transaction_main,
      transaction_so,

      uid,
      address,
      brand,
      car_registration,
      cause,
      customer_id,
      customer_name,
      customer,
      date,
      document_no,
      id,
      model,
      phone,
      status,
      type,
      user,
      warehouse,
      payment_type,
      receipt_type,

      total_pay,
      amount_deposit,
      amount_deposit_need,
      cash_amount,
      transfer_amount,
      transfer_bank_account,
      transfer_date,
      transfer_time,
      credit_amount,
      credit_bank_account,
      credit_date,
      check_number,
      discount,

      product_index,
      serial_list,
      ref_number
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3 pb-5">
          <div className="d-flex justify-content-between mb-2">
            <h4 className="fw-bold mb-3 me-3">ข้อมูลการแจ้งซ่อม ใบแจ้งซ่อม</h4>
          </div>
          <div className="rounded-4 bg-white p-3 mb-3">
            <div className="row mb-3">
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลขที่เอกสาร:</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เลขที่เอกสาร:..."
                  onChange={(e) => {
                    this.setState({ document_no: e.target.value });
                  }}
                  value={document_no}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">วันที่แจ้งซ่อม:</div>
                <input
                  type="date"
                  className="form-control"
                  placeholder="วันที่แจ้งซ่อม..."
                  onChange={(e) => {
                    this.setState({ date: e.target.value });
                  }}
                  value={date}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ผู้ติดต่อ</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ผู้ติดต่อ..."
                  onChange={(e) => {
                    this.setState({ customer_name: e.target.value });
                  }}
                  value={customer_name}
                  disabled={params("type")}
                />
              </div>

              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                  disabled={params("type")}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทรศัพท์</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทรศัพท์..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                  maxLength={10}
                  disabled={params("type")}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ทะเบียนรถ</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ทะเบียนรถ..."
                  onChange={(e) => {
                    this.setState({ car_registration: e.target.value });
                  }}
                  value={car_registration}
                  disabled={params("type")}
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">สถานะ</div>
                <select
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ status: e.target.value });
                  }}
                  value={status}
                  disabled
                >
                  <option value="">เลือกสถานะ</option>

                  <option value="เข้าซ่อม">เข้าซ่อม</option>
                  <option value="รอบันทึกยอดเงิน">รอบันทึกยอดเงิน</option>
                  <option value="รอชำระ">รอชำระ</option>
                  <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทบิล</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ประเภทบิล..."
                  onChange={(e) => {
                    this.setState({ type: e.target.value });
                  }}
                  value={type}
                  disabled
                />
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">รูปแบบชำระ</div>
                <select
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ payment_type: e.target.value });
                  }}
                  value={payment_type}
                  disabled={params("type")}
                >
                  <option value="">เลือกรูปแบบชำระ</option>
                  <option value="ชำระทันที">ชำระทันที</option>
                  <option value="ชำระเชื่อ">ชำระเชื่อ</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">ประเภทใบเสร็จ</div>
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({
                      receipt_type: e.target.value,
                      is_vat: e.target.value === "ต้องการ Vat" ? true : false,
                    });
                  }}
                  value={receipt_type}
                  disabled={params("type")}
                >
                  <option value="">เลือกรูปแบบบิลชำระ</option>
                  <option value="ไม่ต้องการ Vat">ไม่ต้องการ Vat</option>
                  <option value="ต้องการ Vat">ต้องการ Vat</option>
                </select>
              </div>
              <div className="col-6 col-md-4 mb-2">
                <div className="wpx-150 mb-1">เลข SO</div>
                <Select
                  options={data_so}
                  className="form-control"
                  placeholder="เลข SO..." 
                  onChange={(e, i) => {
                    this.setState({ref_number: e});
                    if(e){
                      this.GetSO(i.uid);
                    }else{
                      this.setState({transaction_so: []})
                    }
                  }}
                  value={ref_number}
                  disabled={params("type")}
                />
              </div>
            </div>
            {/* สินค้าเบิกซ่อม */}
            <div>
              <h5 className="fw-bold">สินค้าเบิกซ่อม</h5>
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-end">ต้นทุน</td>
                    <td className="text-nowrap text-end">ราคาต่อหน่วย</td>
                    <td className="text-nowrap text-end">ราคาขาย</td>
                  </tr>
                </thead>
                <tbody>
                  {stock_activity_list?.map((item, index) => (
                    <>
                      <tr>
                        <td
                          className="text-nowrap bg-primary-light fw-bold"
                          colSpan={3}
                        >
                          วันที่เบิก:{" "}
                          {item.created_at ? format_date(item.created_at) : ""}{" "}
                          | {item.document_no}
                        </td>
                        <td
                          className="text-nowrap bg-primary-light fw-bold"
                          colSpan={4}
                        >
                          โกดัง: {item.warehouse?.name}
                        </td>
                      </tr>
                      {item.transaction_list.map((tx, tx_index) => (
                        <tr>
                          <td className="text-nowrap">{tx.product_code}</td>
                          <td className="text-nowrap">{tx.product_name}</td>
                          <td className="text-nowrap">
                            {tx.serial_number.toString()}
                          </td>
                          <td className="text-nowrap text-center">
                            {tx.qty || 0}
                          </td>
                          <td className="text-nowrap text-end">
                            <input
                              type="text"
                              className="form-control text-end"
                              placeholder="0.00"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                stock_activity_list[index].transaction_list[
                                  tx_index
                                ].cost_price = e.target.value;
                                this.setState({
                                  stock_activity_list,
                                  is_change: true,
                                });
                              }}
                              value={tx.cost_price}
                              disabled={params("type")}
                            />
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control text-end"
                              placeholder="0.00"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                stock_activity_list[index].transaction_list[
                                  tx_index
                                ].unit_price = e.target.value;

                                stock_activity_list[index].transaction_list[
                                  tx_index
                                ].sale_price = Number(tx.unit_price) * Number(tx.qty);
                                this.setState({
                                  stock_activity_list,
                                  is_change: true,
                                });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                              }}
                              value={tx.unit_price}
                              disabled={params("type")}
                            />
                          </td>
                          <td className="text-nowrap">
                            <input
                              type="text"
                              className="form-control text-end"
                              placeholder="0.00"
                              onChange={(e) => {
                                if (!float(e.target.value)) return;
                                stock_activity_list[index].transaction_list[
                                  tx_index
                                ].sale_price = e.target.value;
                                this.setState({
                                  stock_activity_list,
                                  is_change: true,
                                });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                              }}
                              value={tx.sale_price}
                              disabled={params("type")}
                            />
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
            {/* สินค้าอื่นๆ */}
            <div>
              <h5 className="fw-bold">สินค้าอื่นๆ</h5>
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap text-center wpx-130">จำนวน</td>
                    <td className="text-nowrap text-end">ต้นทุน</td>
                    <td className="text-nowrap text-end">ราคาต่อหน่วย</td>
                    <td className="text-nowrap text-end">ราคาขาย</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="ชื่อสินค้า"
                          onChange={(e) => {
                            transaction_list[index].product_name =
                              e.target.value;
                            this.setState({ transaction_list });
                          }}
                          value={item.product_name}
                          disabled={params("type")}
                        />
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex justify-content-center">
                          {!params("type") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={async () => {
                                if (item.qty <= 1) {
                                  if (
                                    await alert(
                                      "",
                                      "info",
                                      "ยืนยัน",
                                      "ยืนยันการลบข้อมูลนี้หรือไม่",
                                      "ลบข้อมูล",
                                      "ยกเลิก"
                                    )
                                  ) {
                                    this.setState({
                                      transaction_list: transaction_list.filter(
                                        (_, i) => i !== index
                                      ),
                                    });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                                  }
                                } else {
                                  transaction_list[index].qty = Math.max(
                                    0,
                                    item.qty - 1
                                  );
                                  transaction_list[index].sale_price = Number(item.unit_price) * Number(item.qty);
                                  this.setState({ transaction_list });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                                }
                              }}
                            >
                              -
                            </button>
                          )}
                          <input
                            type="text"
                            className="form-control wpx-50 mx-1 text-center px-1"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[index].qty = Number(
                                e.target.value
                              );
                              transaction_list[index].sale_price = Number(item.unit_price) * Number(item.qty);
                              this.setState({ transaction_list });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                            }}
                            value={item.qty}
                            disabled={params("type")}
                          />
                          {!params("type") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={() => {
                                transaction_list[index].qty = Math.max(
                                  0,
                                  item.qty + 1
                                );
                                transaction_list[index].sale_price = Number(item.unit_price) * Number(item.qty);
                                this.setState({ transaction_list });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                              }}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control text-end"
                          placeholder="0.00"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            transaction_list[index].cost_price = e.target.value;
                            this.setState({ transaction_list });
                          }}
                          value={item.cost_price}
                          disabled={params("type")}
                        />
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[index].unit_price =
                                e.target.value;
                                transaction_list[index].sale_price = Number(item.unit_price) * Number(item.qty);
                              this.setState({ transaction_list });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                            }}
                            value={item.unit_price}
                            disabled={params("type")}
                          />
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_list[index].sale_price =
                                e.target.value;
                              this.setState({ transaction_list });

                                setTimeout(() => {
                                  this.calCostPrice();
                                }, 100);
                            }}
                            value={item.sale_price}
                            disabled={params("type")}
                          />
                          {!params("type") && (
                            <BtnIcon
                              type="delete"
                              onClick={async () => {
                                if (
                                  await alert(
                                    "",
                                    "info",
                                    "ยืนยัน",
                                    "ยืนยันการลบข้อมูลนี้หรือไม่",
                                    "ลบข้อมูล",
                                    "ยกเลิก"
                                  )
                                ) {
                                  this.setState({
                                    transaction_list: transaction_list.filter(
                                      (_, i) => i !== index
                                    ),
                                  });
                                }
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-dark px-3"
                  onClick={() => {
                    if (!params("type")) {
                      this.setState({
                        transaction_list: [
                          ...transaction_list,
                          {
                            product_name: "",
                            qty: 1,
                            cost_price: "",
                            unit_price: "",
                            sale_price: ""
                          },
                        ],
                      });
                    }
                  }}
                >
                  + เพิ่มสินค้าอื่นๆ
                </button>
              </div>
            </div>
            {/* สินค้านำเข้าคลัง */}
            <div>
              <h5 className="fw-bold">สินค้านำเข้าคลัง</h5>
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="bg-secondary-light text-nowrap">
                      รหัส/ชื่อสินค้า
                    </td>
                    <td className="bg-secondary-light text-nowrap">
                      Serial No.
                    </td>
                    <td className="bg-secondary-light text-nowrap">
                      คลังสินค้า
                    </td>
                    <td className="bg-secondary-light text-nowrap text-center wpx-130">
                      จำนวน
                    </td>
                    <td className="bg-secondary-light text-nowrap text-end">
                      ต้นทุน
                    </td>
                    <td className="bg-secondary-light text-nowrap text-end">
                      ราคาต่อหน่วย
                    </td>
                    <td className="bg-secondary-light text-nowrap text-end">
                      ราคาขาย
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_main?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        <Select
                          className="form-control"
                          placeholder="ค้นหาสินค้า..."
                          options={data_product.filter(
                              (e) => e.warehouse_id === item.warehouse_id
                            )}
                          onChange={(e, i) => {
                            transaction_main[index].product_id = e;
                            transaction_main[index].product_code =
                              i.product_code;
                            transaction_main[index].product_name =
                              i.product_name;
                            transaction_main[index].unit_name =
                              i.unit_name;
                            transaction_main[index].serial_number = "";
                            transaction_main[index].balance = i.balance;
                            transaction_main[index].remark = "";
                            this.setState({ transaction_main });
                          }}
                          value={item.product_id}
                          disabled={params("type")}
                        />
                      </td>
                      <td className="text-nowrap">
                        {data_product.find((e) => e.value === item.product_id)
                          ?.is_serial_number && (
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              className="form-control mx-1"
                              onChange={(e) => {
                                transaction_main[index].serial_number =
                                  e.target.value;
                                this.setState({ transaction_main });
                              }}
                              value={item.serial_number}
                              disabled={params("type")}
                            />
                          </div>
                        )}
                      </td>
                      <td className="text-nowrap">
                        <Select
                          className="form-control"
                          placeholder="เลือกคลังสินค้า..."
                          options={data_warehouse}
                          onChange={(e) => {
                            transaction_main[index].warehouse_id = e;
                            this.setState({ transaction_main });
                          }}
                          value={item.warehouse_id}
                          disabled={
                            status === "รอชำระ" ||
                            params("type")
                          }
                        />
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex justify-content-center">
                          {!params("type") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={async () => {
                                if (item.qty <= 1) {
                                  if (
                                    await alert(
                                      "",
                                      "info",
                                      "ยืนยัน",
                                      "ยืนยันการลบข้อมูลนี้หรือไม่",
                                      "ลบข้อมูล",
                                      "ยกเลิก"
                                    )
                                  ) {
                                    this.setState({
                                      transaction_main:
                                        transaction_main.filter(
                                          (_, i) => i !== index
                                        ),
                                    });
                                  }
                                } else {
                                  transaction_main[index].qty =
                                    Math.max(0, item.qty - 1);
                                  this.setState({ transaction_main });
                                }
                              }}
                            >
                              -
                            </button>
                          )}
                          <input
                            type="text"
                            className="form-control wpx-50 mx-1 text-center px-1"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[index].qty = Number(
                                e.target.value
                              );
                              this.setState({ transaction_main });
                            }}
                            value={item.qty}
                            disabled={params("type")}
                          />
                          {!params("type") && (
                            <button
                              className="btn btn-primary wpx-30"
                              onClick={() => {
                                transaction_main[index].qty = Math.max(
                                  0,
                                  item.qty + 1
                                );
                                this.setState({ transaction_main });
                              }}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <input
                          type="text"
                          className="form-control text-end"
                          placeholder="0.00"
                          onChange={(e) => {
                            if (!float(e.target.value)) return;
                            transaction_main[index].cost_price =
                              e.target.value;
                            this.setState({ transaction_main });
                          }}
                          value={item.cost_price}
                          disabled={params("type")}
                        />
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[index].unit_price =
                                e.target.value;

                                transaction_main[index].sale_price = Number(item.unit_price) * Number(item.qty);
                              this.setState({ transaction_main });

                            }}
                            value={item.unit_price}
                            disabled={params("type")}
                          />
                        </div>
                      </td>
                      <td className="text-nowrap">
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control text-end"
                            placeholder="0.00"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              transaction_main[index].sale_price =
                                e.target.value;
                              this.setState({ transaction_main });
                            }}
                            value={item.sale_price}
                            disabled={params("type")}
                          />
                          {!params("type") && (
                            <BtnIcon
                              type="delete"
                              onClick={async () => {
                                if (
                                  await alert(
                                    "",
                                    "info",
                                    "ยืนยัน",
                                    "ยืนยันการลบข้อมูลนี้หรือไม่",
                                    "ลบข้อมูล",
                                    "ยกเลิก"
                                  )
                                ) {
                                  this.setState({
                                    transaction_main:
                                      transaction_main.filter(
                                        (_, i) => i !== index
                                      ),
                                  });
                                }
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {transaction_main.length === 0 && (
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-dark px-3"
                  onClick={() => {
                    if (!params("type")) {
                      this.setState({
                        transaction_main: [
                          ...transaction_main,
                          {
                            product_name: "",
                            qty: 1,
                            cost_price: "",
                            unit_price: "",
                            sale_price: ""
                          },
                        ],
                      });
                    }
                  }}
                >
                  + เพิ่มสินค้านำเข้าคลัง
                </button>
              </div>
              )}
            </div>

             {/* สินค้า SO */}
             {transaction_so.length !== 0 && (
            <div>
              <h5 className="fw-bold text-danger">หัก บิลชำระล่วงหน้า</h5>
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td className="text-nowrap text-center wpx-130">จำนวน</td>
                    <td className="text-nowrap text-end">ต้นทุน</td>
                    <td className="text-nowrap text-end">ราคาต่อหน่วย</td>
                    <td className="text-nowrap text-end">ราคาขาย</td>
                  </tr>
                </thead>
                <tbody>
                  {transaction_so?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.product_name}</td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap text-end">{toFixed(item.cost_price)}</td>
                      <td className="text-nowrap text-end">{toFixed(item.unit_price)}</td>
                      <td className="text-nowrap text-end">{toFixed(item.unit_price * item.qty)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            )}
            <div className="mb-2">
              <div className="wpx-150 mb-1">สาเหตุเบื้องต้น</div>
              <textarea
                rows={5}
                className="form-control"
                placeholder="สาเหตุเบื้องต้น..."
                onChange={(e) => {
                  this.setState({ cause: e.target.value });
                }}
                value={cause}
                disabled={params("type")}
              />
            </div>
            {((status === "รอชำระ" && type === "ซ่อมให้ลูกค้า") ||
              params("type") === "view") && (
              <div className="rounded-4 bg-white p-3">
                <div className="row">
                  <div className="col-12 col-md-6 mb-2"></div>
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>รวมเป็นเงิน</b>
                      <span>
                        {(() => {
                          let _total = 0;
                          stock_activity_list.forEach((e) => {
                            e.transaction_list.forEach((tx) => {
                              _total += Number(tx.sale_price);
                            });
                          });
                          transaction_list.forEach((e) => {
                            _total += Number(e.sale_price);
                          });
                          transaction_so.forEach((e) => {
                            _total -= Number(e.unit_price) * Number(e.qty);
                          });
                          return toFixed(_total || 0);
                        })()}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>ส่วนลด</b>
                      <div className="d-flex align-items-center">
                        {params("type") === "view" ? (
                          toFixed(discount)
                        ) : (
                          <input
                            type="text"
                            className="form-control me-2 text-end wpx-120"
                            onChange={(e) => {
                              if (!float(e.target.value)) return;
                              this.setState({ discount: e.target.value });
                            }}
                            value={discount}
                          />
                        )}{" "}
                        <span>บาท</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>ราคาหลังหักส่วนลด</b>
                      <span>
                        {(() => {
                          let _total = 0;
                          stock_activity_list.forEach((e) => {
                            e.transaction_list.forEach((tx) => {
                              _total += Number(tx.sale_price);
                            });
                          });
                          transaction_list.forEach((e) => {
                            _total += Number(e.sale_price);
                          });
                           transaction_so.forEach((e) => {
                            _total -= Number(e.unit_price) * Number(e.qty);
                          });
                          _total -= Number(discount);
                          return toFixed(_total || 0);
                        })()}{" "}
                        บาท
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>ภาษีมูลค่าเพิ่ม 7%</b>
                      <span>
                        {(() => {
                          let _total = 0;
                          stock_activity_list.forEach((e) => {
                            e.transaction_list.forEach((tx) => {
                              _total += Number(tx.sale_price);
                            });
                          });
                          transaction_list.forEach((e) => {
                            _total += Number(e.sale_price);
                          });
                           transaction_so.forEach((e) => {
                            _total -= Number(e.unit_price) * Number(e.qty);
                          });

                          _total -= Number(discount);
                          if (receipt_type === "ต้องการ Vat") {
                            _total = _total * 0.07;
                          } else {
                            _total = 0;
                          }
                          return toFixed(_total || 0);
                        })()}
                      </span>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <b>จำนวนเงินรวมทั้งหมด</b>
                      <h4 className="fw-bold text-success">
                        {(() => {
                          let _total = 0;
                          stock_activity_list.forEach((e) => {
                            e.transaction_list.forEach((tx) => {
                              _total += Number(tx.sale_price);
                            });
                          });
                          transaction_list.forEach((e) => {
                            _total += Number(e.sale_price);
                          });
                           transaction_so.forEach((e) => {
                            _total -= Number(e.unit_price) * Number(e.qty);
                          });

                          _total -= Number(discount);
                          if (receipt_type === "ต้องการ Vat") {
                            _total = _total * 1.07;
                          }
                          return toFixed(_total || 0);
                        })()}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {status === "รอชำระ" && type === "ซ่อมให้ลูกค้า" && (
            <div>
              <div className="rounded-4 bg-white p-3 mb-3">
                <div className="row">
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>มูลค่าเต็มราคาขาย</span>
                      <b>{toFixed(this.calcBilled() || 0)}</b>
                    </div>
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>มูลค่าที่ชำระแล้ว</span>
                      <b>{toFixed(Number(total_pay))}</b>
                    </div>
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>ยอดค้างชำระ</span>
                      <b className="text-success">{toFixed(this.calcOutstanding())}</b>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>ชำระมัดจำ</span>
                      <input
                        type="text"
                        className="form-control text-end wpx-200 hpx-40"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          const billed = this.calcBilled();
                          const totalPay = Number(this.state.total_pay);
                          let nextAmountDeposit = e.target.value;
                          if (billed < Number(nextAmountDeposit)) {
                            nextAmountDeposit = billed;
                          }
                          this.setState({
                            amount_deposit: nextAmountDeposit,
                            amount_deposit_need: this.calcDefaultPaymentNeed(
                              billed,
                              totalPay,
                              Number(nextAmountDeposit)
                            ),
                          });
                        }}
                        value={amount_deposit}
                        disabled={total_pay > 0}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between hpx-50">
                      <span>ยอดเงินที่ต้องการชำระ</span>
                      <input
                        type="text"
                        className="form-control text-end wpx-200 hpx-40"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          const outstanding = this.calcOutstanding();
                          let val = e.target.value;
                          if (outstanding < Number(val)) {
                            val = outstanding;
                          }
                          this.setState({
                            amount_deposit_need: val,
                          });
                        }}
                        value={amount_deposit_need}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-5 pb-5">
                {/* ชำระเงินสด */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเงินสด</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ cash_amount: e.target.value });
                        }}
                        value={cash_amount}
                      />
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-between mb-3">
                  <span className="wpx-100">เงินทอน</span>
                  <b>{toFixed(cash_amount || 0)} บาท</b>
                </div> */}
                  </div>
                </div>
                {/* ชำระเงินโอน */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเงินโอน</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ transfer_amount: e.target.value });
                        }}
                        value={transfer_amount}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">ธนาคาร</span>
                      <Select
                        options={data_bank}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_bank_account: e });
                        }}
                        value={transfer_bank_account}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">วันที่โอน</span>
                      <DatePicker
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_date: e });
                        }}
                        value={transfer_date}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">เวลาที่โอน</span>
                      <input
                        type="time"
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ transfer_time: e.target.value });
                        }}
                        value={transfer_time}
                      />
                    </div>
                  </div>
                </div>
                {/* ชำระเช็ค */}
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div
                    className="rounded-4 bg-white p-3"
                    style={{ height: "100%" }}
                  >
                    <h5 className="fw-bold mb-0">ชำระเช็ค</h5>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">จำนวนเงิน</span>
                      <input
                        type="text"
                        className="form-control text-end"
                        placeholder="0.00"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ credit_amount: e.target.value });
                        }}
                        value={credit_amount}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">ธนาคาร</span>
                      <Select
                        options={global.bank}
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ credit_bank_account: e });
                        }}
                        value={credit_bank_account}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">วันที่หน้าเช็ค</span>
                      <DatePicker
                        className="form-control"
                        onChange={(e) => {
                          this.setState({ credit_date: e });
                        }}
                        value={credit_date}
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span className="wpx-100">เลขที่เช็ค</span>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                          if (!float(e.target.value)) return;
                          this.setState({ check_number: e.target.value });
                        }}
                        value={check_number}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="hpx-100"></div>
        </div>
        {!params("type") && (
          <div
            className="position-fixed w-100 bg-white d-flex justify-content-end p-3"
            style={{ bottom: 0, left: 0 }}
          >
            <button
              className="btn btn-primary me-2"
              onClick={() => {
                Swal.fire({
                  title: "พิมพ์เอกสาร",
                  text: "",
                  html: `
                    <div class="w-100">
                      <button id="report-installation-summary" class="btn btn-outline-dark w-100 mb-3 text-start">
                        <span class="icon me-2">&#xf15b;</span>
                        ใบสรุปรายการติดตั้ง
                      </button>
                      <button id="report-repair" class="btn btn-outline-dark w-100 mb-3 text-start">
                        <span class="icon me-2">&#xf15b;</span>
                        ใบแจ้งซ่อม
                      </button>
                    </div>
                  `,
                  showConfirmButton: false,
                  showCancelButton: false,
                  showCloseButton: true,
                  didOpen: () => {
                    document.getElementById("report-installation-summary").addEventListener("click", () => {
                      report_installation_summary(uid);
                    });
                    document.getElementById("report-repair").addEventListener("click", () => {
                      report_repair(uid);
                    });
                  }
                });
              }}
            >
              พิมพ์ PDF
            </button>
              <button
                className="btn btn-primary me-2"
                onClick={() => {
                  this.Update();
                }}
              >
                บันทึก
              </button>
            <button
              className="btn btn-dark"
              onClick={async () => {
                let _status =
                  status === "เข้าซ่อม"
                    ? "รอบันทึกยอดเงิน"
                    : status === "รอบันทึกยอดเงิน"
                    ? type === "ซ่อมภายใน" || type === "ประกอบ"
                      ? "เสร็จสิ้น"
                      : "รอชำระ"
                    : status === "รอชำระ"
                    ? "เสร็จสิ้น"
                    : status === "ใบแจ้งหนี้"
                    ? "รอชำระ"
                    : "";
                const total_pay_amount =
                  Number(cash_amount) +
                  Number(transfer_amount) +
                  Number(credit_amount);
                if (status === "รอชำระ" && Number(total_pay_amount) <= 0) {
                  alert(
                    "",
                    "warning",
                    "แจ้งเตือน",
                    "กรุณากรอกจำนวนเงินที่ต้องการชำระ"
                  );
                  return;
                }
                if (
                  payment_type !== "ชำระเชื่อ" &&
                  _status === "เสร็จสิ้น" &&
                  type === "ซ่อมให้ลูกค้า"
                ) {
                  const outstanding = this.normalizeAmount(this.calcOutstanding());
                  const payment_need = this.normalizeAmount(amount_deposit_need);

                  if (total_pay_amount > 0) {
                    if (payment_need <= 0) {
                      alert(
                        "",
                        "warning",
                        "แจ้งเตือน",
                        "ยอดเงินที่ต้องการชำระต้องมากกว่า 0 บาท"
                      );
                      return;
                    }

                    if (this.normalizeAmount(total_pay_amount) !== payment_need) {
                      alert(
                        "",
                        "warning",
                        "แจ้งเตือน",
                        "ยอดชำระไม่เท่ากับยอดเงินที่ต้องการชำระ"
                      );
                      return;
                    }

                    if (this.normalizeAmount(total_pay_amount) > outstanding + 0.01) {
                      alert(
                        "",
                        "warning",
                        "แจ้งเตือน",
                        "ยอดชำระเกินมูลค่าเต็มจำนวนสั่งซื้อ"
                      );
                      return;
                    }
                  }

                  if (total_pay_amount === 0) {
                    _status = "รอชำระ";
                  } else if (outstanding <= this.normalizeAmount(total_pay_amount)) {
                    _status = "เสร็จสิ้น";
                  } else {
                    _status = "รอชำระ";
                  }
                }
                if (
                  await alert(
                    "",
                    "info",
                    "ยืนยัน",
                    status === "รอชำระ"
                      ? "ยืนยันการชำระเงินหรือไม่"
                      : `ยืนยันการเปลี่ยนสถานะข้อมูลนี้เป็น "${
                          status === "เข้าซ่อม"
                            ? "รอบันทึกยอดเงิน"
                            : status === "รอบันทึกยอดเงิน"
                            ? type === "ซ่อมภายใน" || type === "ประกอบ"
                              ? "เสร็จสิ้น"
                              : "รอชำระ"
                            : status === "รอชำระ"
                            ? "เสร็จสิ้น"
                            : status === "ใบแจ้งหนี้"
                            ? "รอชำระ"
                            : ""
                        }" หรือไม่`,
                    "ยืนยัน",
                    "ยกเลิก"
                  )
                ) {
                  this.Update(
                    status === "เข้าซ่อม"
                      ? "รอบันทึกยอดเงิน"
                      : status === "รอบันทึกยอดเงิน"
                      ? type === "ซ่อมภายใน" || type === "ประกอบ"
                        ? "เสร็จสิ้น"
                        : "รอชำระ"
                      : status === "รอชำระ"
                      ? "เสร็จสิ้น"
                      : status === "ใบแจ้งหนี้"
                      ? "รอชำระ"
                      : ""
                  );
                }
              }}
            >
              {status === "รอชำระ" ? "ชำระเงิน" : "บันทึกและเสร็จสิ้น"}
            </button>
          </div>
        )}
        <Modal
          show={modal_serialno}
          onHide={() => this.setState({ modal_serialno: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">เลือก Serial No.</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive mb-3">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-50 text-center">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          this.setState({
                            serial_list: serial_list.map((item) => ({
                              ...item,
                              selected: checked,
                            })),
                          });
                        }}
                        checked={serial_list.every((item) => item.selected)}
                      />
                    </td>
                    <td className="text-nowrap">Serial No.</td>
                  </tr>
                </thead>
                <tbody>
                  {serial_list?.map((item, index) => (
                    <tr style={{ cursor: "pointer" }}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            let _data = [...serial_list];
                            _data[index].selected = e.target.checked;
                            this.setState({ serial_list: _data });
                          }}
                          checked={item.selected}
                        />
                      </td>
                      <td>{item.serial_number}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  let _data = transaction_spare_part;
                  _data[product_index].serial_number = serial_list
                    .filter((e) => e.selected)
                    .map((e) => e.serial_number)
                    .toString();
                  this.setState({
                    transaction_spare_part: _data,
                    modal_serialno: false,
                    product_index: -1,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_serialno: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
